module.exports = __webpack_public_path__ + "img/1515067301.2c8e4c69.jpg";